/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NeonatalTpnViewerAliases {
  CONTEXTUAL_BAR_ACTION_ADJUST_SPEED = 'contextual-bar-action-adjust-speed',
  CONTEXTUAL_BAR_ACTION_REVERSE = 'contextual-bar-action-reverse',
  CONTEXTUAL_BAR_ACTION_TERMINATE = 'contextual-bar-action-terminate',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INTERRUPT_BUTTON = 'interrupt-button',
  NEONATAL_TPN_CONTENT_PANEL = 'neonatal-tpn-content-panel',
  NEONATAL_TPN_DECK = 'neonatal-tpn-deck',
  NEONATAL_TPN_DETAILS_CARD = 'neonatal-tpn-details-card',
  NEONATAL_TPN_FOOTER_PANEL = 'neonatal-tpn-footer-panel',
  NEONATAL_TPN_VIEWER_CONTEXTUAL_BAR = 'neonatal-tpn-viewer-contextual-bar',
  NEONATAL_TPN_VIEWER_LAYOUT = 'neonatal-tpn-viewer-layout',
  PANEL_HEADER = 'panel-header',
  START_BUTTON = 'start-button',
}
export { NeonatalTpnViewerAliases };
